/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//固定ヘッダーの指定
var headerHeight = $('#section-header').outerHeight();

// ページ外アンカーのページ付きリンクへのスムーススクロール
var urlHash = location.hash;
if(urlHash) {
  $('body,html').stop().scrollTop(0);
  setTimeout(function(){
    var target = $(urlHash);
    var position = target.offset().top - headerHeight;
    $('body,html').stop().animate({scrollTop:position}, 500);
  }, 100);
}
// ページ内アンカーのページ付きリンクへのスムーススクロール
$(function(){
  $('a[href*="#"], area[href*="#"]').not(".noScroll").click(function() {
    var speed = 400, // ミリ秒(この値を変えるとスピードが変わる)
      href = $(this).prop("href"), //リンク先を絶対パスとして取得
      hrefPageUrl = href.split("#")[0], //リンク先を絶対パスについて、#より前のURLを取得
      currentUrl = location.href, //現在のページの絶対パスを取得
      currentUrl = currentUrl.split("#")[0]; //現在のページの絶対パスについて、#より前のURLを取得
    //#より前の絶対パスが、リンク先と現在のページで同じだったらスムーススクロールを実行
    if(hrefPageUrl == currentUrl){
      //リンク先の#からあとの値を取得
      href = href.split("#");
      href = href.pop();
      href = "#" + href;
      //スムースクロールの実装
      var target = $(href == "#" || href == "" ? 'html' : href),
          position = target.offset().top - headerHeight; //targetの位置を取得
        $('body,html').stop().animate({scrollTop:position}, 500);
      return false;
    }

  });
});
